import React, { useState } from "react";
import "../styles/main.css";
import { Link } from "gatsby";
import { FaWhatsapp } from "react-icons/fa";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SideBar from "./SideBar";

const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Navbar toggleSidebar={toggleSidebar} />
      <SideBar isOpen={isOpen} toggleSidebar={toggleSidebar} />
      {children}
      <Footer />
      <a
        href="https://wa.me/+584142160265"
        className="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp className="whatsapp-icon"></FaWhatsapp>
      </a>
    </>
  );
};

export default Layout;
